module.exports = __webpack_public_path__ + "img/logo-footer.55526d40.png";